// oxlint-disable-next-line no-unassigned-import
import '@fontsource/roboto/300.css'
// oxlint-disable-next-line no-unassigned-import
import '@fontsource/roboto/400.css'
// oxlint-disable-next-line no-unassigned-import
import '@fontsource/roboto/500.css'
// oxlint-disable-next-line no-unassigned-import
import '@fontsource/roboto/700.css'
// oxlint-disable-next-line no-unassigned-import
import './App.css'

import { CssBaseline, Typography } from '@mui/material'
import { useEffect, useMemo } from 'react'

import AppRoutes from './routes/AppRoutes'
import { BrowserRouter } from 'react-router-dom'
import { DeviceProvider } from './context/DeviceContext'
import { MetaProvider } from './context/MetaContext'
import { PageTitleProvider } from './context/PageTitleContext'
import { ThemeProvider } from '@mui/material/styles'
import { UserProvider } from './context/CurrentUserContext'
import { responsiveFontSizes } from '@mui/material/styles'
import theme from './theme'

function App() {
  useEffect(() => {
    if (window.location.hostname.includes('appspot.com')) {
      const baseUrl = import.meta.env.VITE_SERVER_URL.replace(/\/$/, '')
      const path = window.location.pathname || '/'
      const searchParams = window.location.search || ''
      const hash = window.location.hash || ''

      const normalizedPath = path.startsWith('/') ? path : `/${path}`

      window.location.href = `${baseUrl}${normalizedPath}${searchParams}${hash}`
    }
  }, [])

  const currentTheme = responsiveFontSizes(useMemo(() => theme(), []))
  if (import.meta.env.VITE_MAINTENANCE_MODE === 'true') {
    return (
      <ThemeProvider
        theme={currentTheme}
        storageManager={null}
        defaultMode="system"
      >
        <CssBaseline />
        <div className="App">
          <Typography
            variant="h1"
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              margin: 'auto',
              color: '#0077A3',
            }}
          >
            Under maintenance
          </Typography>
          <Typography
            variant="body1"
            sx={{
              justifyContent: 'center',
              margin: 'auto',
              color: '#0077A3',
            }}
          >
            We will be back soon!
          </Typography>
        </div>
      </ThemeProvider>
    )
  }

  return (
    <ThemeProvider
      theme={currentTheme}
      storageManager={null}
      defaultMode="system"
    >
      <CssBaseline />
      <div className="App">
        <PageTitleProvider>
          <UserProvider>
            <MetaProvider>
              <DeviceProvider>
                <BrowserRouter
                  future={{
                    v7_startTransition: true,
                    v7_relativeSplatPath: true,
                  }}
                >
                  <AppRoutes />
                </BrowserRouter>
              </DeviceProvider>
            </MetaProvider>
          </UserProvider>
        </PageTitleProvider>
      </div>
    </ThemeProvider>
  )
}

export default App
